import { Chain } from "@swapkit/core";
import { isDate } from "date-fns";

import { invariant } from "@coinbot/forge-api/helpers";

import { JSONTransferDetails } from "../schema";

export const formatTransactionDetails = ({
  txHash,
  createdAt,
}: {
  txHash: string | null | undefined;
  createdAt?: Date | null | undefined;
}): JSONTransferDetails => {
  invariant(txHash, "txHash must be supplied to formatTransactionDetails!");

  const details = {
    txHash,
    chain: Chain.THORChain as const,
    createdAt: isDate(createdAt) ? createdAt : new Date(),
  };

  return details;
};
